const indianNumberFormatter = (value) => {
  return new Intl.NumberFormat("en-IN").format(value ?? 0);
};
export default indianNumberFormatter;
